import styled from 'styled-components';
import COLORS from 'shared/constants/colors';

const PaginationContainer = styled.div`
  .MuiPaginationItem-textPrimary.Mui-selected {
    background-color: ${COLORS.BLACK};
    font-weight: bolder;
  }
  .MuiPaginationItem-textPrimary.Mui-selected:hover,
  .MuiPaginationItem-textPrimary.Mui-selected.Mui-focusVisible {
    background-color: ${COLORS.BLACK};
    opacity: 0.5;
  }
`;

export { PaginationContainer };
